module.exports = __webpack_public_path__ + "first-500-glossy_number.jpg?72638fef0ddf6b73b01aea77e05781ee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-500-glossy_number.jpg
// module id = 540
// module chunks = 0